"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const shallow_1 = require("zustand/shallow");
const useAddNewReviewees_1 = require("hooks/useAddNewReviewees/useAddNewReviewees");
const ReviewDeadlineCalendar_1 = __importDefault(require("./ReviewDeadlineCalendar"));
const SettingDeadline = () => {
    const { assignmentEndsAt, handleChangeState } = (0, useAddNewReviewees_1.useAddNewReviewees)((state) => ({
        assignmentEndsAt: state.payloadBody.assignmentEndsAt,
        handleChangeState: state.handleChangeState
    }), shallow_1.shallow);
    const onChangeReviewDeadline = (value) => {
        handleChangeState((draft) => {
            draft.payloadBody.assignmentEndsAt = value;
        });
    };
    return (react_1.default.createElement(ReviewDeadlineCalendar_1.default, { value: assignmentEndsAt, onChange: onChangeReviewDeadline }));
};
exports.default = SettingDeadline;
